exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header{overflow:hidden;padding:50px 25px 10px 20px;height:84px}.header li,.header ul{list-style:none;padding:0;margin:0}.header li li.user-email,.header ul li.user-email{display:none}.header li li.app-headline,.header ul li.app-headline{float:left}.header li li.app-headline h1,.header ul li.app-headline h1{color:#3023ae;font-size:18px;letter-spacing:-1px;font-family:Helvetica Neue,Arial,Helvetica,sans-serif}.header li li.nav-item,.header ul li.nav-item{float:right;font-size:20px;line-height:1.1;margin-left:45px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader?modules&localIdentName=[name]---[local]---[hash:base64:5]!./client/styles/header.styl
// module id = 381
// module chunks = 0